import { cn } from "../../lib/cn";
import { TimePicker } from "./TimePicker";

const TIME_PRESETS = [
  { label: "6 AM", value: "06:00" },
  { label: "9 AM", value: "09:00" },
  { label: "12 PM", value: "12:00" },
  { label: "6 PM", value: "18:00" },
  { label: "9 PM", value: "21:00" },
];

export function ScheduleTimeField({
  value = "09:00",
  onChange,
  disabled = false,
  className,
  layout = "stacked",
}) {
  const presets = (
    <div
      className="flex flex-wrap gap-1.5"
      role="group"
      aria-label="Quick time presets"
    >
      {TIME_PRESETS.map((preset) => {
        const active = value === preset.value;
        return (
          <button
            key={preset.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange?.(preset.value)}
            className={cn(
              "rounded-lg px-2.5 py-1.5 text-xs font-semibold transition-colors",
              active
                ? "bg-brand text-white shadow-sm"
                : "border border-border bg-card text-foreground hover:bg-muted/70",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );

  const timeInput = (
    <TimePicker
      value={value}
      disabled={disabled}
      onChange={onChange}
      className="w-full sm:w-[9.5rem]"
    />
  );

  if (layout === "row") {
    return (
      <div className={cn("space-y-2", className)}>
        {presets}
        {timeInput}
      </div>
    );
  }

  return (
    <div className={cn("space-y-2", className)}>
      {presets}
      {timeInput}
    </div>
  );
}
